import { ILichSuNapDuLieuActionTypes } from "../../action-types/quan-ly-dang-ky/ILichSuNapDuLieuActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { ILichSuNapDuLieuReducer } from "../../reducer-model/quan-ly-dang-ky/ILichSuNapDuLieuReducer";

const iniState: ILichSuNapDuLieuReducer = {
    status: eReducerStatusBase.is_not_initialization,
    data: [],
}

export const lichSuNapDuLieuReducer = (state: ILichSuNapDuLieuReducer = iniState, action: ILichSuNapDuLieuActionTypes): ILichSuNapDuLieuReducer => {
    switch (action.type) {
        case "LICH_SU_NAP_DU_LIEU_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "LICH_SU_NAP_DU_LIEU_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                data: action.payload,
            };
        case "LICH_SU_NAP_DU_LIEU_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        default:
            return state;
    }
}